import { actions } from './actions';

export const reducer = (state, action) => {
  switch (action.type) {

    case actions.getToken:
      return { ...state, getToken: action.payload };

    case actions.token:
      return { ...state, token: action.payload };

    default:
      return state;
  }
};
